<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden")
  kubiqa-website-themes-theme-b-components-shared-top-navigation
  v-row(
    align="end"
    justify="center"
    class="header tw-z-0 tw-mt-3"
    :style="website.pages.home.background_image ? { backgroundImage: `url(${path(website.pages.home.background_image)})` } : ''"
  )
    v-col
      v-row(justify="center")
        v-col(cols="10")
          kubiqa-website-themes-theme-b-components-shared-floating-search-bar
      v-row
        v-col(class="tw-h-16")
  v-row(no-gutters align="center" justify="space-around" class=" tw-bg-blue-accent-3 tw-pt-3")
    v-col(cols="12")
      div(class="tw-grid")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
          kubiqa-website-shared-widget-editor(
            page="home"
            placement="call_out"
            @content="(content) => (content != null ? ((defaultCallout = false), key++) : ((defaultCallout = true), key++))"
          )
        div(v-if="defaultCallout" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
          div(class="tw-h-full  tw-items-center tw-flex")
            v-row(no-gutters justify="center")
              v-col(cols="9")
                span(class="tw-font-bold tw-text-white tw-text-2xl") Find your ideal home
  v-row(no-gutters align="center" justify="space-around" class=" tw-bg-blueGray-lighten-5")
    v-col(cols="12")
      div(class="tw-grid")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1")
          kubiqa-website-shared-widget-editor(
            page="home"
            placement="description"
            @content="(content) => (content != null ? ((defaultDescription = false), key++) : ((defaultDescription = true), key++))"
          )
        div(v-if="defaultDescription" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
          div(class="tw-h-full  tw-items-center tw-flex")
            v-row(no-gutters justify="center")
              v-col(cols="9")
                span(class="tw-font-bold tw-text-white tw-text-2xl") Description
  kubiqa-website-themes-theme-b-components-home-listings
  v-row(class="tw-pt-24 ")
    v-col
  kubiqa-website-themes-theme-b-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      key: 0,
      defaultCallout: null,
      defaultDescription: null,
    };
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
<style lang="stylus">
.header
    background-image: url('~@/components/kubiqa/website/themes/theme-b/images/default-background.jpg');
    width: 100%;
    background-size: cover;
    background-position: bottom;
    height: 0;
    padding: 0;
    height: 550px;
    // background-blend-mode: multiply;
    // background-color: #A0DBFF;
</style>
